module.exports = __webpack_public_path__ + "static/media/garota-nervosa.f444e2b2.jpg";